import { combineReducers } from 'redux'
import loginReducer, { LoginState } from './login.reducer'
import transactionReducer, { TransactionState } from './transaction.reducer'
import transactionEditReducer, { TransactionEditState } from './transaction.edit.reducer'
import documentReducer, { DocumentState } from './document.reducer'
import documentDetailReducer, { DocumentDetailState } from './document.detail.reducer'
import staffReducer, { StaffState } from './staff.reducer'
import branchReducer, { BranchState } from './branch.reducer'
import reportReducer, { ReportState } from './report.reducer'
import policyDetailReducer, { PolicyDetailState } from './policy.detail.reducer'
import paymentDetailReducer, { PaymentDetailState } from './payment.detail.reducer'
import bankAccountReducer, { BankAccountState } from './bankAccount.reducer'
import errorReducer, { ErrorState } from './error.reducer'

export default combineReducers({
  loginReducer,
  transactionReducer,
  transactionEditReducer,
  documentReducer,
  documentDetailReducer,
  staffReducer,
  branchReducer,
  reportReducer,
  policyDetailReducer,
  paymentDetailReducer,
  bankAccountReducer,
  errorReducer
})

export interface RootReducers {
  loginReducer: LoginState
  transactionReducer: TransactionState
  transactionEditReducer: TransactionEditState
  documentReducer: DocumentState
  documentDetailReducer: DocumentDetailState
  staffReducer: StaffState
  branchReducer: BranchState
  reportReducer: ReportState
  policyDetailReducer: PolicyDetailState
  paymentDetailReducer: PaymentDetailState
  bankAccountReducer: BankAccountState
  errorReducer: ErrorState
}
